import React from "react";

import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import {
  useCardManagement,
  AddCardModal,
} from "components/CardManagement";

export function RegisterNewCard({
  addresses,
  cards,
  setCards,
  setRefreshCards,
}) {
  const cardMgmt = useCardManagement({
    cards,
    setCards,
    setRefreshCards,
    addresses,
  });

  return (
    <>
      <AddCardModal cardMgmt={cardMgmt} cards={cards} isMyAccountPage />
      {cards.length === 0 && (
        <p className="font-wl-500">Nenhum cartão cadastrado</p>
      )}
      {cards.map((card) => (
        <div
          key={card.uuid}
          className="d-flex align-items-center justify-content-between"
        >
          <div className="d-flex align-items-center gap-2">
            <label>{card.brand} -</label>
            <label htmlFor="radio1">Final {card.last_four_digits}</label>
          </div>
          <button
            className="btn link-cancel-wl font-wl-500 text-xs"
            onClick={() => cardMgmt.onClickDelCard(card.uuid)}
          >
            EXCLUIR
          </button>
        </div>
      ))}
      <Row>
        <Col className="my-4">
          <button
            className="btn-outline-wl px-4 py-2 text-xs font-wl-700"
            style={{ width: "fit-content" }}
            onClick={cardMgmt.openAddCardModal}
          >
            ADICIONAR CARTÃO
          </button>
        </Col>
      </Row>
    </>
  );
}

RegisterNewCard.propTypes = {
  addresses: PropTypes.array,
  cards: PropTypes.array,
  setCards: PropTypes.func,
  setRefreshCards: PropTypes.func,
};
